import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_UTILS } from 'services/_path';

// ACTIONS
import { addNotifications } from 'store/modules/app/notifications/actions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	confrontarDigitaisCnhSuccess,
	confrontarDigitaisCnhFailure,
} from './actions';
import { DadosBiometricos } from '../consultarDigitais/types';

function* confrontarDigitaisCnhRequest(request: ReducerAction) {
	const { payload } = request;

	const {
		cpf,
		dedoSorteio,
		digital,
	}: { cpf: string; dedoSorteio: DadosBiometricos; digital: string } = payload;

	const response: ApiResponse = yield call(
		postApi,
		PATH_UTILS,
		`/biometria/${CHANNEL}/confronto`,
		{
			cpf,
			imagem: {
				indice: Number(dedoSorteio.posicaoDedo),
				tipo: 'DIGITAL',
				conteudo: digital,
			},
			finalidade: 'REUSO_CNH',
			incluirPendentes: true,
		},
	);

	if (response.status === 200) {
		if (
			response.data.resultado === true ||
			response.data.resultado === 'true'
		) {
			yield put(confrontarDigitaisCnhSuccess(payload));
		} else {
			yield put(confrontarDigitaisCnhFailure());
			addNotifications({
				errors: [
					'A conferência da biometria falhou. Realize o procedimento novamente.',
				],
			});
		}
	} else {
		yield put(confrontarDigitaisCnhFailure());
		addNotifications({
			errors: [
				'A conferência da biometria falhou. Realize o procedimento novamente.',
			],
		});
	}
}

export default all([
	takeLatest(
		Types.CONFRONTAR_DIGITAIS_CNH_REQUEST,
		confrontarDigitaisCnhRequest,
	),
]);
